import React from 'react';

type props = {
  Label: string;
  disableLine?: boolean;
};

const SectionLabel: React.FunctionComponent<props> = ({ Label, disableLine }): JSX.Element => {
  return (
    <div className="w-full">
      <div className={'gray-border-line relative w-full py-3 ' + (disableLine ? '' : ' border-b')}>
        <div className="text-md text-gray-dark font-bold">{Label}</div>
      </div>
    </div>
  );
};

export default SectionLabel;
